// Libraries
import { FC } from "react";
import { Separator } from "@radix-ui/react-separator";

// Types
import { DividerProps, GetSizeClass } from "./Divider.types";

const getSizeClass: GetSizeClass = ({ orientation = "horizontal", size = "full" }) => {
  const sizeMap = {
    horizontal: {
      full: "h-px w-full",
      half: "h-px w-1/2",
      quarter: "h-px w-1/4",
    },
    vertical: {
      full: "w-px h-full",
      half: "w-px h-1/2",
      quarter: "w-px h-1/4",
    },
  };

  return sizeMap[orientation][size];
};

export const Divider: FC<DividerProps> = ({
  orientation = "horizontal",
  size = "full",
  className = "",
  decorative = true,
  children,
}) => {
  const sizeClass = getSizeClass({ orientation, size });

  return (
    <div
      className={`flex flex-row gap-4 items-center justify-center ${
        orientation === "horizontal" ? "w-full" : "h-full"
      }`}
    >
      <Separator
        className={`bg-muted ${sizeClass} ${className}`}
        orientation={orientation}
        decorative={decorative}
      />
      {children && (
        <>
          <span className="text-regular-2 opacity-80">{children}</span>
          <Separator
            className={`bg-muted ${sizeClass} ${className}`}
            orientation={orientation}
            decorative={decorative}
          />
        </>
      )}
    </div>
  );
};
